// extracted by mini-css-extract-plugin
module.exports = {"mobile-nav":"MobileNavigation_mobile-nav__1OnzW","active":"MobileNavigation_active__1TTJ8","mobile-nav__icon":"MobileNavigation_mobile-nav__icon__34UZX"};